// extracted by mini-css-extract-plugin
export default {"Form":"RegistrationForm_Form__cdxUd","Field":"RegistrationForm_Field__UyZ2Z","Text":"RegistrationForm_Text__oSvVe","progress":"RegistrationForm_progress__cSRgI"};